export const GLOBALLY_BLOCKED_RECIPIENT_ADDRESS = 'GLOBALLY_BLOCKED_RECIPIENT_ADDRESS';
export const GLOBALLY_BLOCKED_RECIPIENT_DOMAIN = 'GLOBALLY_BLOCKED_RECIPIENT_DOMAIN';
export const OK = 'OK';
export const OTHER_SUBSCRIPTION_REJECTED = 'OTHER_SUBSCRIPTION_REJECTED';
export const PREVIOUSLY_MARKED_AS_SPAM = 'PREVIOUSLY_MARKED_AS_SPAM';
export const RECIPIENT_PREVIOUSLY_BOUNCED_GLOBALLY = 'RECIPIENT_PREVIOUSLY_BOUNCED_GLOBALLY';
export const RECIPIENT_PREVIOUSLY_BOUNCED_ON_PORTAL = 'RECIPIENT_PREVIOUSLY_BOUNCED_ON_PORTAL';
export const UNSUBSCRIBED_PERSONAL = 'UNSUBSCRIBED_PERSONAL';
export const UNSUBSCRIBED_PORTAL = 'UNSUBSCRIBED_PORTAL';